/* eslint-disable no-param-reassign */
import { createChatgenieAPI } from '@chatgenie/core';
import { URL_API } from '../../constants';
import { store } from '../../redux/store';
import { logout } from '../../providers/Auth0Provider';
import { saveAppId } from '../../redux/modules/users/actions';
import { refreshAccessToken, shouldClearSavedAppId, shouldLogout, updateHeaders } from './utils';

export const chatgenieAPI = createChatgenieAPI({
  baseUrl: `${URL_API}/api`
});

chatgenieAPI.instance.interceptors.request.use(
  async config => {
    config.headers = await updateHeaders(config.headers);
    return config;
  },
  error => Promise.reject(error)
);

chatgenieAPI.instance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const response = error?.response;
    if (response?.status === 401 && !originalRequest.retried) {
      originalRequest.retried = true;
      const token = await refreshAccessToken();
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return chatgenieAPI.instance(originalRequest);
    }
    if (shouldClearSavedAppId(response)) {
      store.dispatch(saveAppId({ appId: '' }));
    } else if (shouldLogout(response)) {
      logout();
      return error;
    }
    return Promise.reject(error);
  }
);
